<template>
  <div>
    <label for="bookingStaffSelected" v-if="isShownLabel"
      >Staff<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingStaffSelected"
      v-model="staff"
      :options="staffs"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingStaffDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    resourceChecking: { type: Boolean, default: false },
    storeCode: { type: String, default: null },
    serviceId: { type: Number, default: null },
    bookingId: { type: Number, default: null },
    time: { type: String, default: null },
    date: { type: String, default: null },
    isShownLabel: { type: Boolean, default: true },
  },
  data() {
    return {
      staff: this.value,
      staffs: [],
    };
  },
  created() {
    if (this.resourceChecking) {
      if (this.serviceId && this.date && this.time) {
        this.getStaffs(
          this.storeCode,
          this.bookingId,
          this.serviceId,
          this.date,
          this.time
        );
      }
    } else if (this.storeCode) {
      this.getStaffs(this.storeCode, null, null, null);
    }
  },
  watch: {
    staff(newValue) {
      this.$emit("setStaff", newValue);
    },
    value(newValue) {
      this.staff = newValue;
    },
    staffs(newValue) {
      this.$emit("setStaffs", newValue);
    },
    storeCode(newStoreCode) {
      if (newStoreCode && !this.resourceChecking) {
        this.getStaffs(newStoreCode, null, null, null, null);
      } else {
        this.staffs = [];
      }
    },
    time(newTime) {
      if (newTime) {
        this.getStaffs(
          this.storeCode,
          this.bookingId,
          this.serviceId,
          this.date,
          newTime
        );
      } else {
        this.staffs = [];
      }
    },
  },
  methods: {
    async getStaffs(storeCode, bookingId, serviceId, date, time) {
      try {
        emitLoadingStart(this);
        await BookingService.getStaffs({
          storeCode: storeCode,
          bookingId: bookingId,
          serviceId: serviceId,
          date: date,
          time: time,
        })
          .then(async (res) => {
            this.staffs = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
  },
};
</script>
